import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "estate-listing__item" }
const _hoisted_2 = { class: "estate-card__header card-block" }
const _hoisted_3 = { class: "estate-card__photos" }
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "estate-card__info" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "estate-card__price-panel card-block" }
const _hoisted_8 = { class: "estate-card__actions" }
const _hoisted_9 = { class: "estate-card__params" }
const _hoisted_10 = { class: "estate-param card-block" }
const _hoisted_11 = { class: "estate-param card-block" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("m"),
  /*#__PURE__*/_createElementVNode("sup", null, "2")
], -1)
const _hoisted_13 = { class: "estate-param date card-block" }
const _hoisted_14 = { class: "estate-param gender card-block" }
const _hoisted_15 = { class: "estate-param card-block" }
const _hoisted_16 = {
  key: 0,
  class: "estate-param card-block"
}
const _hoisted_17 = {
  key: 1,
  class: "estate-param card-block"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("m"),
  /*#__PURE__*/_createElementVNode("sup", null, "2")
], -1)
const _hoisted_19 = {
  key: 2,
  class: "estate-param card-block"
}
const _hoisted_20 = { class: "estate-card__person card-block" }
const _hoisted_21 = { class: "contact-person contact-person--inline" }
const _hoisted_22 = { class: "contact-person__photo" }
const _hoisted_23 = { class: "contact-person__info" }
const _hoisted_24 = { class: "contact-person__name" }
const _hoisted_25 = {
  key: 0,
  class: "contact-person__logo"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdListGallery = _resolveComponent("AdListGallery")!
  const _component_AdListItemPrice = _resolveComponent("AdListItemPrice")!
  const _component_AdListItemLike = _resolveComponent("AdListItemLike")!
  const _component_AdListItemFavorite = _resolveComponent("AdListItemFavorite")!
  const _component_SexIcon = _resolveComponent("SexIcon")!
  const _component_ResizableImage = _resolveComponent("ResizableImage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ReadMore = _resolveComponent("ReadMore")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["estate-card estate-card--compare", _ctx.classByAdType])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.editable)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.remove && _ctx.remove(...args))),
                class: "delete-item"
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_AdListGallery, {
            images: _ctx.ad.images,
            estateType: _ctx.ad.estateType,
            estateSubType: _ctx.ad.estateSubType,
            adGuid: _ctx.ad.adGuid,
            width: 500,
            height: 420
          }, null, 8, ["images", "estateType", "estateSubType", "adGuid"])
        ]),
        _createElementVNode("div", {
          class: "estate-card__title",
          title: _ctx.ad.title
        }, _toDisplayString(_ctx.ad.title), 9, _hoisted_4),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", null, _toDisplayString(_ctx.address), 1),
          (_ctx.ad.publishDate)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t('AdCompareListItem.publishDate')) + ": " + _toDisplayString(_ctx.$filters.date(_ctx.ad.publishDate)), 1))
            : _createCommentVNode("", true),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdCompareListItem.lastChangedDate')) + ": " + _toDisplayString(_ctx.$filters.date(_ctx.ad.lastChangedDate)), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdCompareListItem.id')) + ": " + _toDisplayString(_ctx.ad.adFrontId), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_AdListItemPrice, {
          ad: _ctx.ad,
          showPriceSquare: true
        }, null, 8, ["ad"]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_AdListItemLike, { ad: _ctx.ad }, null, 8, ["ad"]),
          _createVNode(_component_AdListItemFavorite, { ad: _ctx.ad }, null, 8, ["ad"])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.isRoommate)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", null, [
                  _createElementVNode("strong", null, [
                    _createTextVNode(_toDisplayString(_ctx.ad.personCount), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdCompareListItem.personCount')) + " /", 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.ad.bedCount), 1)
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdCompareListItem.bedCount')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", null, [
                  _createElementVNode("strong", null, [
                    _createTextVNode(_toDisplayString(_ctx.ad.estateArea), 1),
                    _hoisted_12
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdCompareListItem.estateArea')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", null, [
                  _createElementVNode("strong", null, [
                    (_ctx.ad.availableFrom)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.$filters.date(_ctx.ad.availableFrom, 'dd. MM.')), 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$filters.date(_ctx.ad.availableFrom, 'yyyy')), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_ctx.$t('AdCompareListItem.availableFrom-now')), 1)
                        ], 64))
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdCompareListItem.availableFrom')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", null, [
                  _createElementVNode("strong", null, [
                    _createVNode(_component_SexIcon, {
                      type: _ctx.ad.adSex
                    }, null, 8, ["type"]),
                    _createTextVNode(_toDisplayString(_ctx.ad.adSexTitle), 1)
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdCompareListItem.sex')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", null, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.ad.adAgeTitle), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdCompareListItem.age')), 1)
                ])
              ])
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.ad.roomCount)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("div", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.ad.roomCount), 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdCompareListItem.roomCount')), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.ad.estateArea)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("div", null, [
                      _createElementVNode("strong", null, [
                        _createTextVNode(_toDisplayString(_ctx.ad.estateArea), 1),
                        _hoisted_18
                      ]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdCompareListItem.estateArea')), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.landArea)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", null, [
                      _createElementVNode("strong", null, [
                        _createTextVNode(_toDisplayString(_ctx.landArea), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdCompareListItem.ares')), 1)
                      ]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdCompareListItem.landArea')), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          (_ctx.isEstateAgency)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_router_link, {
                    to: { name: 'AdAgentList', params: { urlName: _ctx.ad.estateAgentUrlName } }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ResizableImage, {
                        url: _ctx.ad.photoRelativeUrl,
                        placeholder: "img/no-photo-user.png",
                        width: 135,
                        height: 135,
                        alt: _ctx.ad.fullName,
                        onClick: _ctx.onAgentSelect
                      }, null, 8, ["url", "alt", "onClick"])
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.ad.fullName), 1),
                  (!_ctx.isEstateAgencyMode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createVNode(_component_router_link, {
                          to: { name: 'AdAgencyList', params: { urlName: _ctx.ad.estateAgencyUrlName } }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ResizableImage, {
                              classes: "estate-agency-logo",
                              url: _ctx.ad.logoRelativeUrl,
                              placeholder: "img/no-logo-agency.png",
                              width: 80,
                              height: 45,
                              onClick: _ctx.onAgencySelect
                            }, null, 8, ["url", "onClick"])
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_router_link, {
          class: "button button--primary",
          tag: "a",
          to: { name: 'AdDetail', params: { adFrontId: _ctx.ad.adFrontId } }
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('AdCompareListItem.button-detail')), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createVNode(_component_ReadMore, {
        class: "estate-detail-description card-block",
        text: _ctx.ad.description,
        max: 600,
        moreText: _ctx.$t('show-more'),
        lessText: _ctx.$t('show-less')
      }, null, 8, ["text", "moreText", "lessText"])
    ], 2)
  ]))
}